<template>
  <transition name="fade" mode="out-in">
    <div v-show="showMessage" class="messages">
      <transition name="fade" mode="out-in">
        <span class="formErrors" v-if="formErrors > 0"><i class="sherpa-icon icon-ico_error"></i> <span v-html="getLang('formErrors')"></span></span>
      </transition>
      <transition name="fade" mode="out-in">
        <span class="formErrors" v-if="formAddErrors > 0"><i class="sherpa-icon icon-ico_error"></i> <span v-html="getLang('formAddErrors')"></span></span>
      </transition>
      <transition name="fade" mode="out-in">
        <span class="formErrors" v-if="formModifyErrors > 0"><i class="sherpa-icon icon-ico_error"></i> <span v-html="getLang('formModifyErrors')"></span></span>
      </transition>
      <transition name="fade" mode="out-in">
        <span class="formSaved" v-if="formSaved">
          <i class="sherpa-icon icon-ico_ok"></i>
          <span v-html="getLang('formSaved')"></span>
          <span v-if="resultSuccessMsg"><br/><br/>{{ resultSuccessMsg }}</span>
        </span>
      </transition>
      <transition name="fade" mode="out-in">
        <!--
        <popup v-if="resultSuccessMsg"
          :isPopupShown="resultSuccessMsg"
          :title="null"
          :type="null"
          :id="null"
          :txtContent="resultSuccessMsg"
          :language="language"
          :authorization="authorization"
          :visuals="visuals"
          :apiparams="apiparams"
          @popupClose="popupClose"
        />
        -->
      </transition>
      <!--
      <transition name="fade" mode="out-in">
        <span class="formSaved" v-if="formAddSaved"><i class="sherpa-icon icon-ico_ok"></i> <span v-html="getLang('formAddSaved')"></span></span>
      </transition>
      -->
      <transition name="fade" mode="out-in">
        <span class="formErrors" v-if="formSavedError"><i class="sherpa-icon icon-ico_error"></i> <span v-html="formSavedErrorMsg"></span></span>
      </transition>
      <transition name="fade" mode="out-in">
        <span class="formSaved" v-if="formDeleted"><i class="sherpa-icon icon-ico_ok"></i> <span v-html="getLang('formDeleted')"></span></span>
      </transition>
    </div>
  </transition>
</template>

<script>
import language from '../language'
import Popup from '../popup'

export default {
  name: 'action-message',
  components: {
    Popup
  },
  data () {
    return {
      showMessage: false
    }
  },
  props: [
    'language',
    'formErrors',
    'formAddErrors',
    'formModifyErrors',
    'formSaved',
    'formAddSaved',
    'formSavedError',
    'formSavedErrorMsg',
    'formDeleted',
    'resultSuccessMsg',
    'authorization',
    'visuals',
    'apiparams'
  ],
  methods: {
    getLang (key) {
      var result = ''
      result = language(this.language, key)
      return result
    },
    popupClose () {
      this.$emit('popupClose')
    },
    doShowMessage () {
      this.showMessage = true
      var self = this
      setTimeout(function () {
        self.showMessage = false
      }, 3500)
    }
  },
  watch: {
    formErrors (formErrors) {
      this.doShowMessage()
    },
    formAddErrors (formAddErrors) {
      this.doShowMessage()
    },
    formModifyErrors (formModifyErrors) {
      this.doShowMessage()
    },
    formSaved (formSaved) {
      this.doShowMessage()
    },
    resultSuccessMsg (resultSuccessMsg) {
      this.doShowMessage()
    },
    formAddSaved (formAddSaved) {
      // this.doShowMessage()
    },
    formSavedError (formSavedError) {
      this.doShowMessage()
    },
    formDeleted (formDeleted) {
      this.doShowMessage()
    }
  }
}
</script>

<style lang="scss">
.messages {
  margin-top: 8px;
  background-color: transparent;
  border: 0;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10000000;
  background-color: rgba(60,60,60,0.6);

  .formErrors,
  .formSaved {
    vertical-align: middle;
    padding: 14px 20px 13px;
    min-height: 33px;
    border-radius: 5px;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    position: fixed;
    top: 45%;
    left: 0;
    right: 0;
    max-width: 50%;
    margin: 0 auto;

    .sherpa {
      font-size: 14px;
      position: relative;
      top: 2px;
      margin-right:5px;
    }
  }

  .formErrors {
    background-color: #cf0000;
    width: auto;
  }
  .formSaved {
    background-color: #00bb00;
  }
  .formConfirmDelete {
    background-color: #d42e12;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/action/message.vue